import React from 'react';
import { InView } from 'react-intersection-observer';
import styled from 'styled-components';
const FullHeightInView = /*#__PURE__*/styled(InView).withConfig({
  displayName: "RenderInView__FullHeightInView",
  componentId: "sc-ft2tr5-0"
})(["height:100%;"]);
export function RenderInView({
  children,
  onSlideChange,
  index,
  slideRef
}) {
  const slideVisible = inView => {
    if (inView) {
      const {
        offsetParent,
        offsetWidth
      } = slideRef?.current || {};
      // @ts-ignore
      const numSlides = Math.round(offsetParent?.offsetWidth / offsetWidth);
      onSlideChange(index, numSlides);
    }
  };
  return React.createElement(FullHeightInView, {
    threshold: 0.01,
    "data-testid": `render-in-view-${index}`,
    onChange: slideVisible
  }, children);
}